import { ProgramId } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

export const useProgramTimetables = (
  programId: ProgramId,
  options?: SWRConfiguration,
) => {
  const client = useGyymClient()
  return useGyymSWR([client.user.programs.listTimetables, programId], options)
}
